import { mergeAttributes, Node } from "@tiptap/react"

/**
 * JsonHiddenNode: a non-visual node that persists hidden JSON payload alongside visible content.
 * - Renders nothing (display: none) in the editor.
 * - Stores a JSON-serializable payload in attrs (e.g., tokens + references for AI prompts).
 */
export const JsonHiddenNode = Node.create({
	name: "JsonHiddenNode",
	group: "block",
	atom: true,
	selectable: false,
	draggable: false,
	isolating: true,
	defining: false,
	addAttributes() {
		return {
			payload: {
				default: {},
			},
		}
	},
	parseHTML() {
		// Keep it parseable from HTML if ever serialized that way (not typical for this node)
		return [{ tag: "json-hidden" }]
	},
	renderHTML({ HTMLAttributes }) {
		// Render a zero-footprint element; keep attributes for round-trip fidelity.
		// Consumers should not see this in the UI.
		return ["json-hidden", mergeAttributes(HTMLAttributes, { style: "display: none;", "aria-hidden": "true" })]
	},
})
